<script lang="ts">
  import Button, { type AvatarProps } from '$lib/components/common/button/Button.svelte';
  import { Icons, type IconType } from '$lib/components/common/icon';
  import { twMerge } from 'tailwind-merge';

  export let onClick = () => {};

  // Accept 'class' prop for styling
  let classname = '';
  export { classname as class };
  
  export let listClass = '';
  export let label = 'Filter';
  export let size: 'small' | 'medium' | 'large' | 'x-large' = 'small';
  export let icon: IconType | null = null;
  export let avatar: AvatarProps | null = null;
  export let iconPosition: 'left' | 'right' = 'left';
  export let iconSize = '14px';
  export let iconClass = '';
  export let labelForValue = '';
  export let selectedValue = '';
  export let buttonClass = '';
  export let dataTestid = '';
  export let onClearClick = () => {};
  $: showList = false;

  export function toggleShowList(toggle: boolean) {
    showList = toggle;
  }

  const handleButtonClick = () => {
    toggleShowList(!showList);
    onClick();
  };
</script>

<span class={twMerge('alii-filter-button relative flex justify-center', classname)}>
  {#if avatar}
    <Button
      active={showList}
      label={selectedValue}
      fontSize="text-xs"
      variant="outlined"
      {icon}
      {avatar}
      {iconPosition}
      {iconClass}
      {size}
      class={`w-[60px] justify-between !px-0 !pl-[6px] !pr-[4px] ${buttonClass}`}
      onClick={handleButtonClick}
      {dataTestid}
    />
  {:else if selectedValue}
    <button
      data-testid={dataTestid}
      class="relative inline-flex h-8 cursor-pointer appearance-none items-center gap-2 rounded bg-primary-500 p-2 pr-8"
      on:click={handleButtonClick}
    >
      <span class=" text-xs font-medium">
        <span class="text-[--filterLabelForValue]">{labelForValue} </span>
        <span class="text-[--filterSelectedValue]">{selectedValue}</span>
      </span>
      <button class="absolute right-0.5 cursor-pointer p-2 text-[--filterSelectedValue]" on:click={onClearClick}>
        <svelte:component this={Icons['close']} weight="bold" size="12px" />
      </button>
    </button>
  {:else}
    <Button
      active={showList}
      {label}
      {size}
      fontSize="text-xs"
      variant="outlined"
      class={buttonClass}
      {icon}
      {iconPosition}
      {iconClass}
      {iconSize}
      onClick={handleButtonClick}
      {dataTestid}
    />
  {/if}
  {#if showList}
    <div
      class={twMerge(
        `alii-filter-list absolute left-1/2 top-auto z-50 !mt-[42px]
              -translate-x-1/2 rounded-lg border border-surface-900 bg-surface-50 px-2 py-2`,
        listClass
      )}
    >
      <slot />
    </div>
  {/if}
</span>

<style lang="postcss">
  @import '$lib/theme/_mixins.postcss';

  .alii-filter-list {
    @mixin shadow;
  }
</style>
